{
  "common": {
    "entityTypes": {
      "User": "Felhasználó",
      "Department": "Osztály",
      "Role": "Pozíció",
      "Process": "Folyamat",
      "ProcessStepRecording": "Folyamatlépés-rögzítés",
      "ProcessStepAssignment": "Folyamatlépés-hozzárendelés",
      "Survey": "Kérdőív",
      "Artifact": "Dokumentum",
      "ExternalContact": "Külső kapcsolattartó",
      "SoftwareSystem": "Szoftverrendszer",
      "OrgFunction": "Funkció",
      "Organization": "Szervezet",
      "BliksyGeneration": "Bliksy generálás",
      "ProcessConnection": "Folyamatkapcsolat",
      "ProcessChain": "Folyamatlánc",
      "ProcessMapPosition": "Folyamattérkép-pozíció",
      "ProcessMapLaneDimension": "Folyamattérkép sáv mérete",
      "Tenant": "Bérlő",
      "AppRegistry": "Alkalmazás-regiszter",
      "PlatformSettings": "Platformbeállítások"
    },
    "itemsSelected": "{{count}} kiválasztva",
    "selectAll": "Összes kijelölése",
    "showMore": "Több megjelenítése",
    "showLess": "Kevesebb megjelenítése",
    "deleted": "törölve",
    "viewAll": "Összes megtekintése",
    "noItemsFound": "Nem található elem",
    "Yes": "Igen",
    "No": "Nem",
    "Back": "Vissza",
    "back": "Vissza",
    "Done": "Kész",
    "Beta": "Béta",
    "Save": "Mentés",
    "Remove": "Eltávolítás",
    "Edit": "Szerkesztés",
    "Search": "Keresés",
    "Create": "Létrehozás",
    "Continue": "Folytatás",
    "continue": "Folytatás",
    "Submitting": "Küldés...",
    "submit": "Küldés",
    "Settings": "Beállítások",
    "Logout": "Kijelentkezés",
    "loading": "Betöltés...",
    "chatError": "Hiba történt. Kérjük, próbálja újra.",
    "retry": "Újrapróbálás",
    "download": "Letöltés",
    "trialDaysLeft": "Próbaidőszak lejár {{days}} nap múlva",
    "trialLastDay": "Próbaidőszak ma lejár",
    "trialExpired": "Próbaidőszak lejárt",
    "ErrorBoundary": {
      "title": "Hiba történt",
      "description": "Hiba történt az oldal betöltésekor. Próbálja újra, vagy navigáljon másik oldalra az oldalsáv segítségével.",
      "tryAgain": "Újrapróbálás",
      "goToSettings": "Beállítások megnyitása",
      "goHome": "Kezdőlap",
      "viewErrorDetails": "Hiba részleteinek megtekintése"
    },
    "NotFound": {
      "title": "Hamarosan elérhető funkció",
      "description": "Aktívan dolgozunk ezen a funkción. Hamarosan elérhető lesz!",
      "suggestion": "Addig is fedezze fel a többi funkciót, vagy tekintse meg az ütemtervünket.",
      "goToDashboard": "Irányítópult megnyitása",
      "goToLogin": "Bejelentkezés",
      "viewRoadmap": "Ütemterv megtekintése"
    },
    "Apps": {
      "notFound": "Az alkalmazás nem található vagy nem érhető el ehhez a szervezethez.",
      "manageTitle": "Alkalmazáskatalógus",
      "manageDescription": "Aktiválja a szervezete alkalmazásait és ossza ki a helyeket",
      "enabled": "Engedélyezve",
      "disabled": "Letiltva",
      "activation": "Aktiválás",
      "enableSuccess": "Alkalmazás sikeresen engedélyezve.",
      "enableFailed": "Nem sikerült az alkalmazás engedélyezése.",
      "disableSuccess": "Alkalmazás sikeresen letiltva.",
      "disableFailed": "Nem sikerült az alkalmazás letiltása.",
      "seatsTitle": "Alkalmazáshelyek",
      "seatsMembers": "Hozzáféréssel rendelkező személyek",
      "seatsSaved": "Helyek mentve.",
      "seatDataIntro": "Egy hely teljes olvasási hozzáférést ad ebben az alkalmazásban a következő adatokhoz: {{categories}}.",
      "seatDataCategories": {
        "processes": "Folyamatok",
        "processSteps": "Folyamatlépések részletei, beleértve a jegyzeteket, valamint a kapacitás- és költségadatokat",
        "surveys": "Kérdőívválaszok, beleértve az egyes lépések értékeléseit és megjegyzéseit, az esetgyakoriságot és a feldolgozási időt – minden folyamatra, osztálytól függetlenül",
        "systems": "Rendszerek",
        "roles": "Funkciók",
        "teams": "Csapatok",
        "departments": "Osztályok",
        "orgMembers": "Tagnyilvántartás (az e-mail-címmel és az állapottal együtt)",
        "artifacts": "Dokumentumok",
        "externalContacts": "Külső kapcsolatok (az e-mail-címmel együtt)",
        "processChains": "Folyamatláncok (a bennük összekapcsolt folyamatokkal együtt)"
      },
      "notAllowed": "Nem engedélyezett",
      "notAllowedNotice": "Ez az alkalmazás nem engedélyezett a szervezete számára.",
      "seatsCount": "{{used}} / {{limit}} hely",
      "seatsNeedEnabledApp": "Helyeket csak az alkalmazás aktiválása után lehet kiosztani.",
      "seatsOverLimit": "{{over}} a korláton felül",
      "seatsNoCapacity": "Nincs elérhető hely",
      "category": {
        "analysis": "Elemzés",
        "dataCapture": "Adatrögzítés",
        "sales": "Értékesítés"
      }
    },
    "Sidebar": {
      "Dashboard": "Irányítópult",
      "ActiveMonitoring": "Aktív megfigyelés",
      "ComingSoon": "Hamarosan",
      "ensureContinuity": "Az aktív megfigyelés biztosítja az üzletmenet folytonosságát.",
      "AreTheRelevant": "Jelenleg minden releváns folyamattag elérhető?",
      "areThereBottleneck": "Vannak szűk keresztmetszetek a folyamattájképben?",
      "LearnMore": "Tudjon meg többet",
      "Processes": "Folyamatok",
      "AllProcesses": "Összes folyamat",
      "MyTasks": "Feladataim",
      "ProcessLandscape": "Folyamattérkép",
      "ProcessChains": "Folyamatláncok",
      "ProcessEditor": "Folyamatszerkesztő",
      "Organization": "Szervezet",
      "MyDepartment": "Osztályom",
      "MyOrgFunctions": "Funkcióim",
      "MySystems": "Rendszereim",
      "Systems": "Rendszerek",
      "OrgCatalogs": "Szervezeti katalógusok",
      "AllDepartments": "Összes osztály",
      "AllFunctions": "Összes funkció",
      "AllTeams": "Összes csapat",
      "AllMembers": "Összes személy",
      "AllSoftwareSystems": "Összes szoftverrendszer",
      "SystemLandscape": "Rendszertájkép",
      "AllExternalContacts": "Összes külső kapcsolat",
      "AllArtifacts": "Összes dokumentum",
      "OrgChart": "Szervezeti ábra",
      "Analytics": "Elemzések",
      "AiUsage": "MI-használat",
      "SeeWhichPeople": "Nézze meg, kik vagy mely rendszerek kritikusak a folyamataiban, hol van a legnagyobb fejlődési lehetőség?",
      "Survey": "Felmérés",
      "Apps": "Alkalmazások",
      "ManageApps": "Alkalmazások kezelése",
      "DataSync": "Adatszinkronizálás",
      "needSpecificDetail": "Konkrét részletekre van szüksége bizonyos folyamatokról? Ki a szakértő ebben? Fenntarthatósági kérdésekre kell válaszolni?",
      "Settings": "Beállítások",
      "OrgSettings": "Szervezeti beállítások",
      "UserManagement": "Felhasználókezelés",
      "TenantManagement": "Bérlőkezelés",
      "InitialConfig": "Kezdeti konfiguráció",
      "SoftwareSystems": "Szoftverrendszerek",
      "MyOverview": "Munkakörnyezetem",
      "RecordingDashboard": "Felvételi vezérlőpult",
      "AuditLogs": "Auditnapló",
      "ShadowSystems": "Árnyékrendszerek",
      "Help": "Súgó",
      "PartnerContent": "Partnertartalmak",
      "AccountManagement": "Fiókok"
    },
    "Name": "Név",
    "Email": "E-mail",
    "Logo": "Logó",
    "Change": "Módosítás",
    "Upload": "Feltöltés",
    "Created": "Létrehozva",
    "Description": "Leírás",
    "Details": "Részletek",
    "Category": "Kategória",
    "Type": "Típus",
    "Status": "Státusz",
    "FirstName": "Keresztnév",
    "LastName": "Vezetéknév",
    "Actions": "Műveletek",
    "edit": "Szerkesztés",
    "actions": "Műveletek",
    "viewDetail": "Részletek megtekintése",
    "clone": "Duplikálás",
    "Updated": "Frissítve",
    "UserTypes": "Felhasználótípusok",
    "Classification": "Besorolás",
    "DepartmentManager": "Osztályvezető",
    "Error": "Hiba",
    "errorOccurred": "Hiba történt",
    "success": "Sikeres",
    "save": "Mentés",
    "cancel": "Mégse",
    "close": "Bezárás",
    "confirm": "Megerősítés",
    "processing": "Feldolgozás...",
    "sending": "Küldés...",
    "delete": "Törlés",
    "create": "Létrehozás",
    "confirmDelete": "Törlés megerősítése",
    "confirmDeleteDescription": "Biztosan törölni szeretné {{entity}}? Ez a művelet nem vonható vissza.",
    "unsavedChanges": "Nem mentett módosítások",
    "unsavedChangesDescription": "Nem mentett módosításai vannak. Biztosan be szeretné zárni?",
    "stay": "Szerkesztés folytatása",
    "discardChanges": "Módosítások elvetése",
    "noOptionsAvailable": "Nincs elérhető lehetőség",
    "Instructions": "Utasítások",
    "add": "Hozzáadás",
    "search": "Keresés",
    "searchOrCreate": "Keresés vagy létrehozás...",
    "noResults": "Nincs találat.",
    "uploading": "Feltöltés",
    "uploadingEllipsis": "Feltöltés...",
    "or": "Vagy",
    "you": "Ön",
    "moreCount": "(+{{count}} további)",
    "dropzone": {
      "dragAndDrop": "Húzza ide, vagy",
      "clickToSelect": "kattintson a fájlok kiválasztásához",
      "maxFileSize": "Max. {{maxSize}} MB fájlok engedélyezettek",
      "rejectedType": "Nem lett hozzáadva – nem támogatott fájltípus: {{names}}",
      "rejectedSize": "Nem lett hozzáadva – nagyobb, mint {{maxSize}} MB: {{names}}"
    },
    "notAvailable": "N/A",
    "system": "Rendszer",
    "empty": "(üres)",
    "error": "Hiba",
    "excelUpload": {
      "downloadTemplateTitle": "Sablon letöltése",
      "downloadTemplateDesc": "Pontosan ezeket az oszlopokat tartalmazza – töltse ki és töltse fel.",
      "parsedRows": "{{count}} sor beolvasva",
      "parseFailed": "A fájl nem olvasható",
      "headerMismatch": "Egyik oszlop sem egyezik a sablonnal. Kérjük, használja a sablon oszlopfejléceit.",
      "dragOrBrowse": {
        "prefix": "Húzza ide, vagy",
        "browse": "kattintson a fájlok kiválasztásához"
      },
      "maxFileSize": "Maximális fájlméret 10 MB"
    },
    "Workspaces": "Munkaterületek",
    "Help": "Súgó"
  },
  "userTypes": {
    "system_admin": "Rendszergazda",
    "system_admin_description": "Teljes rendszerhozzáférés és konfiguráció",
    "org_manager": "Szervezeti menedzser",
    "org_manager_description": "Szervezeti beállítások és tagok kezelése",
    "org_member": "Szervezeti tag",
    "org_member_description": "Alap hozzáféréssel rendelkező tag",
    "partner_admin": "Partner admin",
    "partner_admin_description": "Kezeli a partnerszervezet leadjeit, csapatát és profilját",
    "partner_staff": "Partner munkatárs",
    "partner_staff_description": "Rögzíti és követi saját leadjeit a partner felületen"
  },
  "userStatus": {
    "inactive": "Inaktív",
    "pending": "Függőben",
    "active": "Aktív",
    "suspended": "Felfüggesztett"
  },
  "userClassification": {
    "internal": "Belső munkatárs",
    "external": "Külső munkatárs",
    "internalShort": "Belső",
    "externalShort": "Külső"
  },
  "seatLimits": {
    "title": "Helykorlátok",
    "systemAdmins": "Rendszergazdák",
    "orgManagers": "Szervezeti menedzserek",
    "members": "Alapfelhasználók"
  },
  "bpmnEventTypes": {
    "none": "Kézi indítás",
    "none_description": "Egy személy indítja el manuálisan",
    "message": "Beérkező kérés",
    "message_description": "Beérkező kérés váltja ki (pl. e-mail, hívás vagy üzenet)",
    "timer": "Időpont / Határidő",
    "timer_description": "Egy adott időpontban vagy határidő lejártakor aktiválódik",
    "conditional": "Feltételes",
    "conditional_description": "Feltétel teljesülésekor aktiválódik",
    "signal": "Jelzés",
    "signal_description": "Jelzés küldésekor aktiválódik",
    "multiple": "Többszörös",
    "multiple_description": "Több trigger, egy szükséges",
    "parallelMultiple": "Párhuzamos többszörös",
    "parallelMultiple_description": "Több trigger, mind szükséges",
    "error": "Hiba",
    "error_description": "Hiba esetén aktiválódik",
    "cancel": "Mégse",
    "cancel_description": "Tranzakció törlésekor aktiválódik",
    "escalation": "Eszkaláció",
    "escalation_description": "Eszkaláció esetén aktiválódik",
    "compensation": "Kompenzáció",
    "compensation_description": "Kompenzáció kezelésére aktiválódik",
    "link": "Link",
    "link_description": "A folyamat másik részéhez kapcsolódik",
    "terminate": "Lezárás",
    "terminate_description": "Azonnal befejezi a folyamatot"
  },
  "pageTitles": {
    "home": "Kezdőlap",
    "login": "Bejelentkezés",
    "myTasks": "Feladataim",
    "myTasksWithCount": "Feladataim ({{count}})",
    "processDetail": "{{name}}",
    "processFlowFullscreen": "{{name}} - Folyamat vizualizáció",
    "allProcesses": "Összes folyamat",
    "createProcesses": "Folyamatok létrehozása",
    "startRecording": "Rögzítés indítása - {{name}}",
    "stepRecording": "Rögzítés - {{name}}",
    "orgMembers": "Személyek",
    "orgMemberDetail": "{{name}}",
    "departments": "Osztályok",
    "departmentDetail": "{{name}}",
    "mySystems": "Rendszereim",
    "orgFunctionDetail": "{{name}}",
    "functions": "Funkciók",
    "teams": "Csapatok",
    "myOrgFunctions": "Funkcióim",
    "systems": "Rendszerek",
    "systemDetail": "{{name}}",
    "systemLandscape": "Rendszertájkép",
    "processMap": "Folyamattérkép",
    "processChains": "Folyamatláncok",
    "processEditor": "Folyamatszerkesztő",
    "artifacts": "Dokumentumok",
    "artifactDetail": "{{name}}",
    "externalContacts": "Külső kapcsolatok",
    "externalContactDetail": "{{name}}",
    "orgChart": "Szervezeti ábra",
    "settings": "Beállítások",
    "tenants": "Bérlők",
    "departmentMembers": "Személyek az osztályomon",
    "departmentTeams": "Osztályom csapatai",
    "userManagement": "Felhasználókezelés",
    "softwareList": "Szoftverlista",
    "manageApps": "Alkalmazások kezelése",
    "dataSync": "Adatszinkronizálás",
    "createDepartments": "Osztályok létrehozása",
    "dashboard": "Munkakörnyezetem",
    "shadowSystems": "Árnyékrendszerek",
    "help": "Ügyfélszolgálat",
    "supportTickets": "Support jegyek"
  },
  "noDashboardAccess": {
    "title": "Még nincs hozzáférés munkaterülethez",
    "description": "Fiókja nem fér hozzá munkaterület-nézethez. Kérjük, forduljon a rendszergazdához a megfelelő szerepkör hozzárendeléséhez."
  },
  "about": {
    "title": "A BLIKS IO-ról",
    "frontendVersion": "Frontend",
    "backendVersion": "Backend",
    "buildInfo": "Build"
  },
  "helpCenter": {
    "title": "Ügyfélszolgálat",
    "subtitle": "Küldjön be egy kérést és kövesse nyomon jegyeit",
    "contactUs": "Kapcsolat & Támogatás",
    "contactSubtitle": "Lépjen kapcsolatba ügyfélszolgálatunkkal",
    "viewTickets": "Jegyeim",
    "openTicketsCount": "Nyitott jegyek: {{count}}",
    "ticketsWithNewReplyCount": "Új válasszal rendelkező jegyek: {{count}}",
    "contact": {
      "category": "Kategória",
      "categoryPlaceholder": "Miben segíthetünk?",
      "categories": {
        "incident": "Probléma bejelentése",
        "request": "Kérés benyújtása",
        "change": "Változtatás kérése",
        "complaint": "Panasz benyújtása"
      },
      "summary": "Tárgy",
      "summaryPlaceholder": "Kérése rövid összefoglalása",
      "description": "Leírás",
      "descriptionPlaceholder": "Kérjük, részletesen írja le kérését...",
      "submit": "Kérés elküldése",
      "successTitle": "Kérés elküldve!",
      "successMessage": "Kérését elküldtük. Csapatunk hamarosan felveszi Önnel a kapcsolatot.",
      "errorMessage": "Hiba történt. Kérjük, próbálja újra vagy írjon a {{supportEmail}} címre.",
      "newRequest": "Új kérés benyújtása",
      "ticketReference": "Jegyszám: {{number}}",
      "attachmentsTitle": "Képernyőképek csatolása",
      "attachmentsHint": "Legfeljebb {{count}} kép, egyenként max. {{size}} MB (PNG, JPEG, WebP)",
      "attachmentRemove": "{{name}} eltávolítása"
    }
  },
  "supportTickets": {
    "newReply": "Új válasz",
    "title": "Support jegyek",
    "subtitle": "Tekintse meg támogatási kéréseit",
    "loadErrorTitle": "Nem sikerült betölteni a jegyeit",
    "loadError": "A támogatás átmenetileg nem érhető el. Kérjük, próbálja újra később.",
    "empty": "Nincsenek jegyek",
    "emptyDescription": "Még nem hozott létre support jegyet.",
    "open": "Nyitott",
    "closed": "Lezárt",
    "status": {
      "received": "Beérkezett",
      "inProgress": "Folyamatban",
      "resolved": "Lezárva",
      "merged": "Összevonva"
    },
    "detail": {
      "title": "Támogatási kérés",
      "loadErrorTitle": "A kérés nem tölthető be",
      "loadError": "A támogatás átmenetileg nem érhető el. Kérjük, próbálja meg később.",
      "noMessages": "Ehhez a kéréshez még nincsenek üzenetek.",
      "notLiveChat": "Nem élő chat – a válaszok itt és e-mailben érkeznek, általában rövid időn belül.",
      "authorYou": "Ön",
      "authorSupport": "Támogatás",
      "replyLabel": "Válasz",
      "replyPlaceholder": "Írjon választ a támogatásnak...",
      "replySubmit": "Válasz küldése",
      "sendShortcut": "⌘/Ctrl + Enter",
      "attach": "Kép csatolása",
      "replyError": "A válasz elküldése nem sikerült. Kérjük, próbálja újra.",
      "resolvedHint": "Ez a kérés lezárult. Ha valami még nyitott, újra megnyithatja.",
      "mergedNotice": "Ezt a kérést egy másik kéréssel összevontuk, és ott dolgozzuk fel tovább.",
      "mergedLink": "Ugrás a(z) #{{number}} kéréshez",
      "reopenAction": "Kérés újranyitása",
      "reopenLabel": "Mi maradt még nyitva?",
      "reopenSubmit": "Küldés és újranyitás",
      "attachmentDownload": "{{name}} letöltése",
      "attachmentDownloadAction": "Letöltés",
      "attachmentOpen": "{{name}} megnyitása",
      "attachmentError": "A melléklet letöltése nem sikerült. Kérjük, próbálja újra."
    }
  }
}
